import { IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
import { TableIcon } from '../../../../../sprouts/components/Icons/TableIcon';
import { TableViewDialog } from './TableViewDialog';
import { useTableViewData } from './useTableViewData';

type Props = {
  isDataLoading: boolean;
  customerId: string;
};

export const TableViewLauncher = ({ isDataLoading, customerId }: Props) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const { data: tableViewData, isLoading: isTableViewDataLoading } =
    useTableViewData(isDataLoading);

  return (
    <Stack
      direction='row'
      sx={{
        padding: 5,
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderColor: 'divider',
        alignItems: 'center',
      }}
    >
      <Typography variant='h6'>{t('Cluster Count')}</Typography>
      <IconButton onClick={() => setOpen(true)} aria-label={t('Open Table')}>
        <TableIcon
          sx={(theme) => ({
            width: '1rem',
            height: '1rem',
            color: theme.vars.palette.text.secondary,
          })}
        />
      </IconButton>
      <TableViewDialog
        open={open}
        onClose={() => setOpen(false)}
        customerId={customerId}
        data={tableViewData || []}
        isLoading={isTableViewDataLoading}
      />
    </Stack>
  );
};
